import React from "react";

function TrafficHomeOne({ className }) {
  return (
    <section className={`appie-service-area pt-140 pb-180 ${className || ""}`}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="appie-traffic-title">
              <h3 className="title">Carrom Rules and Regulations</h3>
              <p>a. Common Rules</p>
              <ul>
                <li>• Best of 3 Boards for all matches</li>
                <li>• Common Draw for Men &amp; Women</li>
              </ul>
              <p>
                • It will be a solo tournament 2 players will sit opposite to
                each other.
              </p>
              <p>
                • Initial Break: The game starts with a "break." The first
                player strikes the Striker to hit the carrom men.
              </p>
              <p>
                • The Striker must touch both lines on the board while striking
                and should be placed on the full circle when taking the strike
                from the circle. If not followed it will be considered as foul
                and one carrom men will be lost
              </p>
              <p>
                • The objective is to pocket your carrom men by striking them
                with the Striker. If a player successfully pockets a carrom man,
                they get to shoot again.
              </p>
              <p>
                • Pairing and choice of start will be done randomly. No personal
                preferences will be given.
              </p>
              <p>
                • Time Control: (a time duration will be mentioned on the given
                day of the tournament), players will have to complete the game
                within the time limit. Once the time limit is over the player
                with more carrom men captured will win. In case of draw both the
                players will proceed in the next round.
              </p>
              <p>• A player with more than 1 draw match will be eliminated.</p>
              <p>
                • KNOCKOUT system will be followed in this tournament (Till top
                3/5 players are left)
              </p>
              <p>
                • Once you lose a game you cannot further participate in the
                tournament.
              </p>
              <p>
                • No of Rounds will be determined on the tournament day
                (Tentative 6).
              </p>
              <p>
                • No player is allowed to see/help the other player in a game by
                any means of verbal communication/gestures etc, if caught doing
                so the player will directly get eliminated.
              </p>
              <p>
                • Players are expected to adhere to a code of conduct, which
                includes maintaining sportsmanship, not distracting or
                interfering with opponents, and following the rules and
                regulations of the tournament. The decision by the referee will
                be final and binding.
              </p>
              <p>
                • Scoring System : Black Piece(10 Points), White Piece (20
                Points), Queen (50 Points)
              </p>
              <p>
                • In order to win the player must pocket maximum/all carrom men
                before the opponent does.
              </p>
              <ul>
                <li>
                  <h5>Fouls:</h5>
                </li>
              </ul>
              <p>• Pocketing the striker (loses a carrom man).</p>
              <p>
                • Striker Pocketed: If a player pockets the striker during their
                turn, it is considered a foul. The player loses one carrom man,
                and their turn ends. The pocketed striker is placed back on the
                board.
              </p>
              <p>
                • Double Due: If a player pockets the striker and a carrom men
                together during their turn, he/she has to return the striked
                carrom men along with losing one carrom men and their turn ends.
              </p>
              <p>
                • Striker Off the Board: If the striker completely leaves the
                playing surface of the carrom board during a strike, it is
                considered a foul. The player loses one carrom man, and their
                turn ends. The striker is placed back on the board.
              </p>
              <p>
                • Thumbshot or backshot where the striker directly comes in
                contact with the carrom men is prohibited
              </p>
              <ul>
                <li>• All Rebound shots are allowed</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TrafficHomeOne;
